import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';

import Tag from '../Tag';

import * as Style from './styles';

function ListItemComponent({
    icon,
    handleClick,
    index,
    count,
    showText,
    showTag,
}) {
    const location = useLocation().pathname;
    const userProfile = useSelector(state => state.user.profile);
    const isFromAnimaleOrFabula = userProfile.marcaFilial === 1 || userProfile.marcaFilial === 5

    const isItemSelected = () => {
        const iconRoute = icon.route;
        return iconRoute === location;
    }
    const isSelected = isItemSelected();

    function renderText(icon) {
        if (showText) {
            return (
                <ListItemText
                    disableTypography
                    primary={icon.text}
                    style={{
                        color: '#E3E3E3',
                        fontWeight: 'none',
                    }}
                />
            );
        }
        return null;
    }

    return (
        <Style.ListItemComponent
            primary={isSelected}
            key={`${icon.name}-${index}`}
            onClick={event => handleClick(icon, event)}
            disableGutters
        >
            <Style.ListItemBorder primary={isSelected} />
            <Style.ListItemIconContainer>
                {icon.isSubItem ? (
                    <Style.SubItemIconSpacer />
                ) : icon.name === 'insights' ? (
                    <Style.StyledBadge badgeContent={count}>
                        <Style.IconComponent
                            key={icon.name}
                            primary={isSelected}
                        >
                            {icon.name}
                        </Style.IconComponent>
                    </Style.StyledBadge>
                ) : (
                    <Style.IconComponent key={icon.name} primary inputMargin>
                        {icon.name}
                    </Style.IconComponent>
                )}
            </Style.ListItemIconContainer>
            {renderText(icon)}

            {icon.text === 'Operacional Omni' && showTag && (
                <Tag title="Novidade" />
            )}

            {icon.text === 'Conteúdo para posts' && showTag && isFromAnimaleOrFabula && (
                <Tag title="Novidade" />
            )}
        </Style.ListItemComponent>
    );
}

export default ListItemComponent;
